import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { LogoLockup } from "../components/brand/Brand";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/app");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col paper-grain">
      <header className="max-w-5xl w-full mx-auto px-6 pt-7">
        <Link to="/"><LogoLockup /></Link>
      </header>
      <main className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-sm lr-card p-8">
          <h1 className="font-serif text-2xl text-lr-charcoal">Founder sign in</h1>
          <p className="text-sm text-lr-leather mt-1 mb-6">Access the Long Range operating system.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-lr-charcoal">Email</Label>
              <Input id="email" type="email" data-testid="login-email" value={email}
                onChange={(e) => setEmail(e.target.value)} required className="mt-1 bg-white/60" />
            </div>
            <div>
              <Label htmlFor="password" className="text-lr-charcoal">Password</Label>
              <Input id="password" type="password" data-testid="login-password" value={password}
                onChange={(e) => setPassword(e.target.value)} required className="mt-1 bg-white/60" />
            </div>
            <Button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full h-11 bg-lr-olive hover:bg-[#3d4230] text-lr-cream rounded-[4px]">
              {loading ? "Signing in…" : "Sign in"}
            </Button>
          </form>
        </div>
      </main>
    </div>
  );
}
